export const state = () => ({
  dark: {
    type: 'dark-pickled-bluewood',
    variant: 'navbar-shadow'
  },
  light: {
    type: 'light',
    variant: 'body border-bottom-2'
  }
})

export default {
  namespaced: true,
  state
}